export const defaultSettings = {
  headingColor: "white",
  headingText: "",  // "" => (WorkspaceName || CompanyName)
  linkColor: "yellow",
  linkText: "",
  linkUrl: undefined,
  messageColor: "white",
  messageText: "",
};
